import {
  Button,
  EmptyState,
  Flex,
  Link,
  OctagonAlertIcon,
  Text,
} from '@buffer-mono/popcorn'

import { ChannelRefreshCard } from './ChannelRefreshCard'
import type { RefreshableChannel } from './ChannelRefreshCard'
import styles from './ChannelNeedsRefresh.module.css'

import type { JSX } from 'react'

export const CHANNEL_REFRESH_HELP_URL =
  'https://support.buffer.com/en-us/articles/refreshing-a-channel-in-buffer-7oDS4jk7l1'

const SUPPORT_URL = 'https://support.buffer.com'

function openSupportChat(): void {
  if (window.Beacon) {
    window.Beacon('open')
  } else {
    window.open(SUPPORT_URL, '_blank', 'noopener,noreferrer')
  }
}

export function ChannelRefreshUnsuccessful({
  channel,
}: {
  channel: RefreshableChannel
}): JSX.Element {
  return (
    <EmptyState variant="critical" className={styles.emptyState}>
      <EmptyState.Icon>
        <OctagonAlertIcon />
      </EmptyState.Icon>
      <EmptyState.Heading>
        We couldn&apos;t refresh your channel connection
      </EmptyState.Heading>
      <EmptyState.Description>
        Try refreshing the connection to start replying to comments.{' '}
        <Link external href={CHANNEL_REFRESH_HELP_URL}>
          Learn more
        </Link>
        .
      </EmptyState.Description>
      <EmptyState.Actions className={styles.actions}>
        <Flex
          direction="column"
          gap="md"
          align="center"
          className={styles.recoveryActions}
        >
          <ChannelRefreshCard
            channel={channel}
            cta="publish-comments-button-refresh-1"
          />
          <Flex direction="row" align="center">
            <Text size="md" color="subtle">
              Need help?
            </Text>
            <Button variant="tertiary" size="small" onClick={openSupportChat}>
              Contact our support team
            </Button>
          </Flex>
        </Flex>
      </EmptyState.Actions>
    </EmptyState>
  )
}
